import { Component, OnInit, Input, Output, EventEmitter, TemplateRef } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'j-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss']
})
export class InputComponent implements OnInit {
  @Input() disabled: boolean;
  @Input() control: FormControl;
  @Input() containerClassName = '';
  @Input() icon: string;
  @Input() label: string;
  @Input() iconSize = 16;
  @Input() fullWidth = false;
  @Input() placeholder = '';
  @Input() enableClearButton: boolean;
  @Input() enableEditButton: boolean;
  @Input() alwaysEditButton: boolean = false;
  @Input() editFontType: string = 'edit';
  @Input() editButtonColor : string;
  @Input() editPopoverTemplate: TemplateRef<any>;
  @Output() clickEdit = new EventEmitter<void>();

  get iconContainerWidth(): number {
    return this.iconSize * 2;
  }

  get isShowClearButton(): boolean {
    return this.enableClearButton && this.control?.value;
  }

  get isShowEditButton(): boolean {
    return this.enableEditButton && (this.control?.value || this.alwaysEditButton);
  }

  constructor() {}

  ngOnInit(): void {
    this.control = this.control ?? new FormControl('');
  }

  clear() {
    this.control.patchValue('');
  }

  edit() {
    this.clickEdit.emit();
  }

}
